module.exports = __webpack_public_path__ + "img/title-bg.c4c7fb58.png";